export function formatDurationMS(totalMS: number): string {
    return `${totalMS.toFixed(1)}\u202Fms`
}
